import { Icon, Tooltip } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import {
  actionButtonCss,
  actionButtonIconNudgeCss,
  messageActionsCss,
} from './MessageActions.styles';

interface MessageActionsProps {
  id: string;
  allowRedo?: boolean;
  onCopy?: () => void;
  onRedo?: () => void;
}

export const MessageActions: FC<MessageActionsProps> = ({ id, allowRedo, onCopy, onRedo }) => (
  <div className={messageActionsCss}>
    {/* Ensure the id starts with a letter as it is used as a CSS selector, and 'id' could start with a number */}
    <Tooltip uniqueId={`copy-${id}`} content="Copy" place="bottom">
      <button className={actionButtonCss} type="button" aria-label="Copy" onClick={onCopy}>
        <Icon className={actionButtonIconNudgeCss} name="copy" size={16} />
      </button>
    </Tooltip>
    {allowRedo && (
      // Ensure the id starts with a letter as it is used as a CSS selector, and 'id' could start with a number
      <Tooltip uniqueId={`redo-${id}`} content="Redo" place="bottom">
        <button className={actionButtonCss} type="button" aria-label="Redo" onClick={onRedo}>
          <Icon name="refresh" size={16} />
        </button>
      </Tooltip>
    )}
  </div>
);

MessageActions.displayName = 'MessageActions';
